import React, { memo } from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Member/Subscription/Footer/index";
import { openEmailClient } from "@/src/utils";
// import { useMemberUser } from "@/src/hooks/useMemberUser";

const I18n = I18nUtil.createScoped(Translations);

interface FooterProps {
  text: string;
  email?: string;
  className?: string;
  title?: string;
  onContact?: () => void;
}

const Footer: React.FC<FooterProps> = ({
  text,
  email = "support@edgen.tech",
  title = I18n.t("Contact Us"),
  onContact,
  className,
}) => {
  // const { data: userPlanInfo } = useMemberUser();
  // 处理点击事件，优先使用传入的onContact回调，否则打开邮箱
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (onContact) {
      onContact();
      return;
    }
    // if (userPlanInfo?.isExpert) {
    //   openDiscordLink();
    // } else {
    openEmailClient();
    // }
  };

  return (
    <div
      className={cn(
        `flex flex-row items-center gap-3  mt-auto flex justify-center pt-12 pb-15 z-11`,
        className,
      )}
    >
      <span className="text-content_primary body_medium_s md:body_medium_l">
        {text}
      </span>
      <span
        data-openreplay-label={`${title} - Contact via email ${email} | ${` ${title}`}`}
        className="text-content_accent4_primary body_medium_s md:body_medium_l cursor-pointer flex flex-row items-center gap-1"
        onClick={handleClick}
        aria-label={`${title} - Contact via email ${email}`}
      >
        {` ${title}`}
        <Icon
          name="arrow-right"
          size={20}
          className="text-content_accent4_primary"
        />
      </span>
    </div>
  );
};

export default memo(Footer);
